import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatMap = {
  iso: 'YYYY-MM-DD',
  eur: 'DD.MM.YYYY',
  usa: 'MM/DD/YYYY',
}

export const formatDateTime = (
  date,
  userTimezone,
  userDateFormat,
  showTime = false,
  convertTimeZone = true,
) => {
  let format = formatMap[userDateFormat] || 'YYYY-MM-DD'

  if (showTime) {
    format = `${format} HH:mm:ss`
  }

  return convertTimeZone
    ? dayjs.utc(date).tz(userTimezone).format(format)
    : dayjs.utc(date).format(format)
}
